import { render } from "./KeywordManagement.vue?vue&type=template&id=e77e9cce&scoped=true"
import script from "./KeywordManagement.vue?vue&type=script&lang=js"
export * from "./KeywordManagement.vue?vue&type=script&lang=js"

import "./KeywordManagement.vue?vue&type=style&index=0&id=e77e9cce&scoped=true&lang=scss"
import "./KeywordManagement.vue?vue&type=style&index=1&id=e77e9cce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77e9cce"]])

export default __exports__